import React from 'react'
import { Badge } from 'react-bootstrap'

const ShowStatus = (props) => {
  return (
    <div>
      {props.data.status === 0 &&  <Badge
        pill
        bg="warning"
        text="white"
        style={{ width: "100px", fontSize: "13px" , paddingBottom:"8px"}}
      >
        Pending
      </Badge>}
      {props.data.status === 1 && <Badge
        pill
        bg="success"
        text="white"
        style={{ width: "100px", fontSize: "13px" , paddingBottom:"8px"}}
      >
        Active
      </Badge>}
      {props.data.status === 2 && <Badge
        pill
        bg="danger"
        text="white"
        style={{ width: "100px", fontSize: "13px" , paddingBottom:"8px"}}
      >
        Deactivate
      </Badge>}
      {props.data.status === 3 && <Badge
        pill
        bg="danger"
        text="white"
        style={{ width: "100px", fontSize: "13px" , paddingBottom:"8px"}}
      >
        Reported
      </Badge>}
    </div>
  )
}

export default ShowStatus
